// Copyright (c) 2026 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2026 by '/pkg/go/foundational/mime/generate/client/generator.go'
// This file is intended for version control.

/** getContentType returns the content types accepted by the API. **/
export const getContentTypes = (): string[] => {
  return [
    "text/plain",
    "text/csv",
    "text/vtt",
    "text/markdown",
    "application/json",
    "application/pdf",
    "google/slides",
    "google/documents",
    "image/jpeg",
    "image/tiff",
    "image/bmp",
    "image/webp",
    "application/java-vm",
    "audio/x-wav",
    "audio/x-aiff",
    "audio/basic",
    "application/x-midi",
    "audio/midi",
    "application/vnd.ms-htmlhelp",
    "application/chm",
    "application/x-chm",
    "text/x-java-source",
    "text/x-c++src",
    "text/x-groovy",
    "application/pkcs7-signature",
    "application/pkcs7-mime",
    "application/dif+xml",
    "image/vnd.dwg",
    "application/x-ibooks+zip",
    "application/epub+zip",
    "application/x-elf",
    "application/x-sharedlib",
    "application/x-executable",
    "application/x-msdownload",
    "application/x-coredump",
    "application/x-object",
    "application/atom+xml",
    "application/rss+xml",
    "application/x-font-adobe-metric",
    "application/x-font-ttf",
    "image/x-ozi",
    "application/x-snodas",
    "application/x-ecrg-toc",
    "image/envisat",
    "application/x-doq2",
    "application/x-rs2",
    "application/x-gsag",
    "application/x-ers",
    "application/fits",
    "application/x-pnm",
    "image/adrg",
    "application/x-generic-bin",
    "application/x-bt",
    "application/x-zmap",
    "image/eir",
    "application/x-ace2",
    "application/grass-ascii-grid",
    "application/x-l1b",
    "application/x-gsc",
    "image/jp2",
    "image/hfa",
    "image/fits",
    "image/raster",
    "application/x-epsilon",
    "image/x-srp",
    "application/x-envi-hdr",
    "application/x-ctable2",
    "application/x-srtmhgt",
    "application/jaxa-pal-sar",
    "application/x-ndf",
    "application/sdts-raster",
    "application/x-gtx",
    "application/x-rst",
    "application/x-xyz",
    "application/terragen",
    "application/x-gs7bg",
    "image/arg",
    "application/elas",
    "image/big-gif",
    "application/x-geo-pdf",
    "application/x-ctg",
    "application/aaigrid",
    "application/x-lcp",
    "application/x-nwt-grc",
    "application/x-fast",
    "application/x-usgs-dem",
    "application/x-nwt-grd",
    "application/x-ingr",
    "application/x-envi",
    "application/x-rik",
    "application/x-blx",
    "application/x-wcs",
    "image/ceos",
    "application/x-ngs-geoid",
    "application/x-r",
    "application/x-http",
    "application/x-til",
    "application/x-pds",
    "application/x-rasterlite",
    "application/x-gmt",
    "application/x-msgn",
    "image/ilwis",
    "application/aig",
    "application/x-rmf",
    "image/x-hdf5-image",
    "image/sar-ceos",
    "application/x-kro",
    "application/vrt",
    "application/x-netcdf",
    "image/nitf",
    "image/png",
    "image/geotiff",
    "image/x-mff2",
    "application/x-webp",
    "image/ida",
    "application/x-gsbg",
    "application/x-ntv2",
    "application/x-coasp",
    "application/x-los-las",
    "application/x-tsx",
    "application/x-bag",
    "image/fit",
    "application/x-lan",
    "application/x-map",
    "application/x-dods",
    "application/jdem",
    "application/gff",
    "application/x-isis2",
    "application/x-isis3",
    "application/xpm",
    "application/x-pcidsk",
    "application/x-gxf",
    "application/x-wms",
    "application/x-cosar",
    "image/bsb",
    "application/x-grib",
    "application/x-mbtiles",
    "application/x-cappi",
    "application/x-rpf-toc",
    "image/x-mff",
    "image/x-dimap",
    "image/x-pcraster",
    "application/x-ppi",
    "application/x-sdat",
    "application/pcisdk",
    "application/x-cpg",
    "application/leveller",
    "image/sgi",
    "image/x-fujibas",
    "image/x-airsar",
    "application/x-e00-grid",
    "application/x-kml",
    "application/x-p-aux",
    "application/x-doq1",
    "application/dted",
    "application/x-dipex",
    "application/geotopic",
    "text/iso19139+xml",
    "application/x-grib2",
    "application/x-hdf",
    "application/x-asp",
    "application/xhtml+xml",
    "application/vnd.wap.xhtml+xml",
    "text/html",
    "image/bpg",
    "image/x-bpg",
    "image/x-icon",
    "image/vnd.wap.wbmp",
    "image/x-xcf",
    "image/vnd.adobe.photoshop",
    "text/vnd.iptc.anpa",
    "application/x-isatab",
    "application/vnd.apple.iwork",
    "application/vnd.apple.numbers",
    "application/vnd.apple.keynote",
    "application/vnd.apple.pages",
    "message/rfc822",
    "application/x-matlab-data",
    "application/mbox",
    "application/vnd.ms-outlook-pst",
    "application/x-msaccess",
    "application/x-mspublisher",
    "application/x-tika-msoffice",
    "application/vnd.ms-excel",
    "application/sldworks",
    "application/x-tika-msworks-spreadsheet",
    "application/vnd.ms-powerpoint",
    "application/x-tika-msoffice-embedded; format=ole10_native",
    "application/vnd.ms-project",
    "application/x-tika-ooxml-protected",
    "application/msword",
    "application/vnd.ms-outlook",
    "application/vnd.visio",
    "application/vnd.ms-excel.sheet.3",
    "application/vnd.ms-excel.sheet.2",
    "application/vnd.ms-excel.workspace.3",
    "application/vnd.ms-excel.workspace.4",
    "application/vnd.ms-excel.sheet.4",
    "application/x-tnef",
    "application/ms-tnef",
    "application/vnd.ms-tnef",
    "application/vnd.ms-excel.sheet.macroenabled.12",
    "application/vnd.ms-powerpoint.presentation.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.openxmlformats-officedocument.presentationml.template",
    "application/vnd.ms-excel.addin.macroenabled.12",
    "application/vnd.ms-word.document.macroenabled.12",
    "application/vnd.ms-excel.template.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
    "application/vnd.ms-powerpoint.addin.macroenabled.12",
    "application/vnd.ms-word.template.macroenabled.12",
    "application/x-tika-ooxml",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "audio/mpeg",
    "video/3gpp2",
    "audio/aac",
    "video/mp4",
    "video/quicktime",
    "audio/mp4",
    "audio/m4a",
    "audio/x-m4a",
    "application/mp4",
    "video/x-m4v",
    "video/3gpp",
    "image/x-ms-bmp",
    "image/gif",
    "application/x-vnd.oasis.opendocument.graphics-template",
    "application/vnd.sun.xml.writer",
    "application/x-vnd.oasis.opendocument.text",
    "application/x-vnd.oasis.opendocument.text-web",
    "application/x-vnd.oasis.opendocument.spreadsheet-template",
    "application/vnd.oasis.opendocument.formula-template",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.image-template",
    "application/x-vnd.oasis.opendocument.graphics",
    "application/vnd.oasis.opendocument.chart-template",
    "application/vnd.oasis.opendocument.presentation-template",
    "application/x-vnd.oasis.opendocument.image-template",
    "application/vnd.oasis.opendocument.formula",
    "application/x-vnd.oasis.opendocument.image",
    "application/vnd.oasis.opendocument.spreadsheet-template",
    "application/x-vnd.oasis.opendocument.chart-template",
    "application/x-vnd.oasis.opendocument.formula",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.text-web",
    "application/vnd.oasis.opendocument.text-template",
    "application/vnd.oasis.opendocument.text",
    "application/x-vnd.oasis.opendocument.formula-template",
    "application/x-vnd.oasis.opendocument.spreadsheet",
    "application/x-vnd.oasis.opendocument.chart",
    "application/vnd.oasis.opendocument.text-master",
    "application/x-vnd.oasis.opendocument.text-master",
    "application/x-vnd.oasis.opendocument.text-template",
    "application/vnd.oasis.opendocument.graphics",
    "application/vnd.oasis.opendocument.graphics-template",
    "application/x-vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.image",
    "application/x-vnd.oasis.opendocument.presentation-template",
    "application/vnd.oasis.opendocument.chart",
    "application/x-bzip",
    "application/x-bzip2",
    "application/gzip",
    "application/x-gzip",
    "application/x-xz",
    "application/x-tar",
    "application/x-tika-unix-dump",
    "application/java-archive",
    "application/x-7z-compressed",
    "application/x-archive",
    "application/x-cpio",
    "application/zip",
    "application/x-rar-compressed",
    "application/rtf",
    "video/x-flv",
    "application/xml",
    "text/xml",
    "image/svg+xml",
    "application/x-fictionbook+xml",
    "audio/x-oggflac",
    "audio/x-flac",
    "application/kate",
    "application/ogg",
    "audio/x-oggpcm",
    "video/x-oggyuv",
    "video/x-dirac",
    "video/x-ogm",
    "audio/ogg",
    "video/x-ogguvs",
    "video/theora",
    "video/x-oggrgb",
    "video/ogg",
    "audio/opus",
    "audio/ogg; codecs=opus",
    "audio/speex",
    "audio/ogg; codecs=speex",
    "audio/vorbis",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "video/webm",
  ];
};

/** contentTypeForExtension maps a lowercased extension to the content type the API records it as. **/
export const contentTypeForExtension: ReadonlyMap<string, string> = new Map([
  [".txt", "text/plain"],
  [".text", "text/plain"],
  [".csv", "text/csv"],
  [".vtt", "text/vtt"],
  [".md", "text/markdown"],
  [".markdown", "text/markdown"],
  [".mdown", "text/markdown"],
  [".mkdn", "text/markdown"],
  [".mkd", "text/markdown"],
  [".mdwn", "text/markdown"],
  [".mdtxt", "text/markdown"],
  [".mdtext", "text/markdown"],
  [".json", "application/json"],
  [".pdf", "application/pdf"],
  [".gslides", "google/slides"],
  [".gdoc", "google/documents"],
  [".jpg", "image/jpeg"],
  [".jpeg", "image/jpeg"],
  [".jpe", "image/jpeg"],
  [".jif", "image/jpeg"],
  [".jfif", "image/jpeg"],
  [".jfi", "image/jpeg"],
  [".tif", "image/tiff"],
  [".tiff", "image/tiff"],
  [".bmp", "image/bmp"],
  [".webp", "image/webp"],
  [".class", "application/java-vm"],
  [".wav", "audio/x-wav"],
  [".aiff", "audio/x-aiff"],
  [".aif", "audio/x-aiff"],
  [".aifc", "audio/x-aiff"],
  [".au", "audio/basic"],
  [".snd", "audio/basic"],
  [".mid", "application/x-midi"],
  [".midi", "application/x-midi"],
  [".chm", "application/vnd.ms-htmlhelp"],
  [".java", "text/x-java-source"],
  [".cpp", "text/x-c++src"],
  [".cxx", "text/x-c++src"],
  [".cc", "text/x-c++src"],
  [".groovy", "text/x-groovy"],
  [".p7s", "application/pkcs7-signature"],
  [".p7m", "application/pkcs7-mime"],
  [".p7c", "application/pkcs7-mime"],
  [".dif", "application/dif+xml"],
  [".dwg", "image/vnd.dwg"],
  [".ibooks", "application/x-ibooks+zip"],
  [".epub", "application/epub+zip"],
  [".elf", "application/x-elf"],
  [".so", "application/x-sharedlib"],
  [".exe", "application/x-executable"],
  [".dmp", "application/x-coredump"],
  [".o", "application/x-object"],
  [".atom", "application/atom+xml"],
  [".rss", "application/rss+xml"],
  [".afm", "application/x-font-adobe-metric"],
  [".ttf", "application/x-font-ttf"],
  [".ozi", "image/x-ozi"],
  [".snodas", "application/x-snodas"],
  [".ecrg", "application/x-ecrg-toc"],
  [".envi", "image/envisat"],
  [".doq2", "application/x-doq2"],
  [".rs2", "application/x-rs2"],
  [".gsag", "application/x-gsag"],
  [".ers", "application/x-ers"],
  [".fits", "application/fits"],
  [".pnm", "application/x-pnm"],
  [".adrg", "image/adrg"],
  [".bin", "application/x-generic-bin"],
  [".bt", "application/x-bt"],
  [".zmap", "application/x-zmap"],
  [".eir", "image/eir"],
  [".ace2", "application/x-ace2"],
  [".grd", "application/grass-ascii-grid"],
  [".l1b", "application/x-l1b"],
  [".gsc", "application/x-gsc"],
  [".jp2", "image/jp2"],
  [".hfa", "image/hfa"],
  [".ras", "image/raster"],
  [".eps", "application/x-epsilon"],
  [".srp", "image/x-srp"],
  [".hdr", "application/x-envi-hdr"],
  [".ctable2", "application/x-ctable2"],
  [".srtm", "application/x-srtmhgt"],
  [".jaxa", "application/jaxa-pal-sar"],
  [".ndf", "application/x-ndf"],
  [".sdts", "application/sdts-raster"],
  [".gtx", "application/x-gtx"],
  [".rst", "application/x-rst"],
  [".xyz", "application/x-xyz"],
  [".ter", "application/terragen"],
  [".gs7bg", "application/x-gs7bg"],
  [".arg", "image/arg"],
  [".elas", "application/elas"],
  [".biggif", "image/big-gif"],
  [".geopdf", "application/x-geo-pdf"],
  [".ctg", "application/x-ctg"],
  [".lcp", "application/x-lcp"],
  [".grc", "application/x-nwt-grc"],
  [".fast", "application/x-fast"],
  [".dem", "application/x-usgs-dem"],
  [".ingr", "application/x-ingr"],
  [".rik", "application/x-rik"],
  [".blx", "application/x-blx"],
  [".wcs", "application/x-wcs"],
  [".ceos", "image/ceos"],
  [".geoid", "application/x-ngs-geoid"],
  [".r", "application/x-r"],
  [".http", "application/x-http"],
  [".til", "application/x-til"],
  [".pds", "application/x-pds"],
  [".gmt", "application/x-gmt"],
  [".msgn", "application/x-msgn"],
  [".mpr", "image/ilwis"],
  [".mpl", "image/ilwis"],
  [".aig", "application/aig"],
  [".rmf", "application/x-rmf"],
  [".h5", "image/x-hdf5-image"],
  [".sar", "image/sar-ceos"],
  [".kro", "application/x-kro"],
  [".vrt", "application/vrt"],
  [".nc", "application/x-netcdf"],
  [".cdf", "application/x-netcdf"],
  [".ntf", "image/nitf"],
  [".nitf", "image/nitf"],
  [".png", "image/png"],
  [".mff2", "image/x-mff2"],
  [".ida", "image/ida"],
  [".gsbg", "application/x-gsbg"],
  [".ntv2", "application/x-ntv2"],
  [".coasp", "application/x-coasp"],
  [".las", "application/x-los-las"],
  [".tsx", "application/x-tsx"],
  [".bag", "application/x-bag"],
  [".fit", "image/fit"],
  [".lan", "application/x-lan"],
  [".map", "application/x-map"],
  [".dods", "application/x-dods"],
  [".jdem", "application/jdem"],
  [".gff", "application/gff"],
  [".gff3", "application/gff"],
  [".isis", "application/x-isis2"],
  [".pm", "application/xpm"],
  [".pcidsk", "application/x-pcidsk"],
  [".gxf", "application/x-gxf"],
  [".wms", "application/x-wms"],
  [".cosar", "application/x-cosar"],
  [".bsb", "image/bsb"],
  [".grb", "application/x-grib"],
  [".grb1", "application/x-grib"],
  [".grb2", "application/x-grib"],
  [".mbtiles", "application/x-mbtiles"],
  [".cappi", "application/x-cappi"],
  [".toc", "application/x-rpf-toc"],
  [".mff", "image/x-mff"],
  [".dim", "image/x-dimap"],
  [".pcraster", "image/x-pcraster"],
  [".ppi", "application/x-ppi"],
  [".sdat", "application/x-sdat"],
  [".cpg", "application/x-cpg"],
  [".lev", "application/leveller"],
  [".sgi", "image/sgi"],
  [".rgb", "image/sgi"],
  [".rgba", "image/sgi"],
  [".bw", "image/sgi"],
  [".fujibas", "image/x-fujibas"],
  [".airsar", "image/x-airsar"],
  [".e00", "application/x-e00-grid"],
  [".kml", "application/x-kml"],
  [".aux", "application/x-p-aux"],
  [".doq1", "application/x-doq1"],
  [".dted", "application/dted"],
  [".dipex", "application/x-dipex"],
  [".gt", "application/geotopic"],
  [".xml", "text/iso19139+xml"],
  [".hdf", "application/x-hdf"],
  [".hdf4", "application/x-hdf"],
  [".hdf5", "application/x-hdf"],
  [".he2", "application/x-hdf"],
  [".he5", "application/x-hdf"],
  [".asp", "application/x-asp"],
  [".xhtml", "application/xhtml+xml"],
  [".xht", "application/xhtml+xml"],
  [".html", "text/html"],
  [".htm", "text/html"],
  [".shtml", "text/html"],
  [".bpg", "image/bpg"],
  [".ico", "image/x-icon"],
  [".wbmp", "image/vnd.wap.wbmp"],
  [".xcf", "image/x-xcf"],
  [".psd", "image/vnd.adobe.photoshop"],
  [".anpa", "text/vnd.iptc.anpa"],
  [".isatab", "application/x-isatab"],
  [".pages", "application/vnd.apple.iwork"],
  [".key", "application/vnd.apple.iwork"],
  [".numbers", "application/vnd.apple.iwork"],
  [".eml", "message/rfc822"],
  [".mat", "application/x-matlab-data"],
  [".mbox", "application/mbox"],
  [".pst", "application/vnd.ms-outlook-pst"],
  [".mdb", "application/x-msaccess"],
  [".pub", "application/x-mspublisher"],
  [".doc", "application/msword"],
  [".xls", "application/vnd.ms-excel"],
  [".ppt", "application/vnd.ms-powerpoint"],
  [".xlt", "application/vnd.ms-excel"],
  [".xla", "application/vnd.ms-excel"],
  [".sldprt", "application/sldworks"],
  [".sldasm", "application/sldworks"],
  [".slddrw", "application/sldworks"],
  [".xlr", "application/x-tika-msworks-spreadsheet"],
  [".pot", "application/vnd.ms-powerpoint"],
  [".pps", "application/vnd.ms-powerpoint"],
  [".ppa", "application/vnd.ms-powerpoint"],
  [".mpp", "application/vnd.ms-project"],
  [".mpt", "application/vnd.ms-project"],
  [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  [".pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  [".msg", "application/vnd.ms-outlook"],
  [".vsd", "application/vnd.visio"],
  [".vst", "application/vnd.visio"],
  [".vss", "application/vnd.visio"],
  [".vsw", "application/vnd.visio"],
  [".xlw", "application/vnd.ms-excel.sheet.3"],
  [".tnef", "application/x-tnef"],
  [".xlsm", "application/vnd.ms-excel.sheet.macroenabled.12"],
  [".pptm", "application/vnd.ms-powerpoint.presentation.macroenabled.12"],
  [".xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  [".potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  [".xlam", "application/vnd.ms-excel.addin.macroenabled.12"],
  [".docm", "application/vnd.ms-word.document.macroenabled.12"],
  [".xltm", "application/vnd.ms-excel.template.macroenabled.12"],
  [".dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  [".ppsm", "application/vnd.ms-powerpoint.slideshow.macroenabled.12"],
  [".ppam", "application/vnd.ms-powerpoint.addin.macroenabled.12"],
  [".dotm", "application/vnd.ms-word.template.macroenabled.12"],
  [".ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  [".mp3", "audio/mpeg"],
  [".mpga", "audio/mpeg"],
  [".mp2", "audio/mpeg"],
  [".mp2a", "audio/mpeg"],
  [".3g2", "video/3gpp2"],
  [".aac", "audio/aac"],
  [".mp4", "video/mp4"],
  [".m4a", "video/mp4"],
  [".m4p", "video/mp4"],
  [".m4b", "video/mp4"],
  [".m4r", "video/mp4"],
  [".m4v", "video/mp4"],
  [".mov", "video/quicktime"],
  [".qt", "video/quicktime"],
  [".3gp", "video/3gpp"],
  [".3gpp", "video/3gpp"],
  [".gif", "image/gif"],
  [".otg", "application/x-vnd.oasis.opendocument.graphics-template"],
  [".sxw", "application/vnd.sun.xml.writer"],
  [".odt", "application/x-vnd.oasis.opendocument.text"],
  [".oth", "application/x-vnd.oasis.opendocument.text-web"],
  [".ots", "application/x-vnd.oasis.opendocument.spreadsheet-template"],
  [".otf", "application/vnd.oasis.opendocument.formula-template"],
  [".odp", "application/vnd.oasis.opendocument.presentation"],
  [".oti", "application/vnd.oasis.opendocument.image-template"],
  [".odg", "application/x-vnd.oasis.opendocument.graphics"],
  [".otc", "application/vnd.oasis.opendocument.chart-template"],
  [".otp", "application/vnd.oasis.opendocument.presentation-template"],
  [".odf", "application/vnd.oasis.opendocument.formula"],
  [".odi", "application/x-vnd.oasis.opendocument.image"],
  [".ods", "application/vnd.oasis.opendocument.spreadsheet"],
  [".ott", "application/vnd.oasis.opendocument.text-template"],
  [".odc", "application/x-vnd.oasis.opendocument.chart"],
  [".odm", "application/vnd.oasis.opendocument.text-master"],
  [".bz", "application/x-bzip"],
  [".bz2", "application/x-bzip2"],
  [".gz", "application/gzip"],
  [".xz", "application/x-xz"],
  [".tar", "application/x-tar"],
  [".jar", "application/java-archive"],
  [".7z", "application/x-7z-compressed"],
  [".a", "application/x-archive"],
  [".ar", "application/x-archive"],
  [".cpio", "application/x-cpio"],
  [".zip", "application/zip"],
  [".rar", "application/x-rar-compressed"],
  [".rtf", "application/rtf"],
  [".flv", "video/x-flv"],
  [".svg", "image/svg+xml"],
  [".svgz", "image/svg+xml"],
  [".fb2", "application/x-fictionbook+xml"],
  [".oga", "audio/x-oggflac"],
  [".ogg", "audio/x-oggflac"],
  [".flac", "audio/x-flac"],
  [".kate", "application/kate"],
  [".ogv", "video/x-oggyuv"],
  [".drc", "video/x-dirac"],
  [".ogm", "video/x-ogm"],
  [".opus", "audio/opus"],
  [".spx", "audio/speex"],
  [".webm", "video/webm"],
]);
